import React, { useState } from 'react';
import { Link } from 'gatsby';
import DropdownLevelOneItem from './dropdownLevelOneItem/DropdownLevelOneItem';

const Dropdown = ({ menuItems, value, scrolled, footers }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenLevelTwo, setIsOpenLevelTwo] = useState(false);
  const [activeItem, setActiveItem] = useState(null);

  const toggleDropdown = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  const handleMouseEnterLevelOne = (menuItem) => {
    setActiveItem(menuItem);
    if (menuItem.menuItems?.length > 0) {
      setIsOpenLevelTwo(true);
    } else {
      setIsOpenLevelTwo(false);
    }
  };

  const handleMouseLeaveLevelTwo = () => {
    setActiveItem(null);
    setIsOpenLevelTwo(false);
  };

  return (
    <div
      className="flex relative"
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <button
        type="button"
        aria-label={`${value} dropdown`}
        className={`text-sm ${scrolled ? 'text-customGray-900' : 'text-white'} px-4 py-2 global-hover`}
        onClick={toggleDropdown}
      >
        {value}
      </button>
      <div
        className={`absolute flex flex-row right-0 mr-4 mt-10 transform shadow-lg transition duration-300 ease-out origin-top-right ${
          isOpen || isOpenLevelTwo ? 'scale-100' : 'scale-0'
        }`}
        onMouseLeave={handleMouseLeaveLevelTwo}
      >
        <ul
          className={`flex flex-1 flex-col bg-white min-h-full max-h-[calc(100vh-100px)] overflow-y-auto cursor-pointer ${isOpenLevelTwo ? 'rounded-r-md' : 'rounded-md'} min-w-[240px]`}
        >
          {menuItems.map((menuItem) => (
            <DropdownLevelOneItem
              key={menuItem.title}
              menuItem={menuItem}
              handleMouseEnterLevelOne={handleMouseEnterLevelOne}
              activeItem={activeItem}
            />
          ))}
          {footers?.length > 0 &&
            footers.map((footer) => (
              <li
                key={footer.id}
                className="mx-3"
                onMouseEnter={handleMouseLeaveLevelTwo}
              >
                <Link
                  to={footer.href}
                  className="flex w-full text-sm text-customGray-900 py-3 global-hover border-t border-customGray-300"
                >
                  {footer.text}
                </Link>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
};

export default Dropdown;
